import { TripOutput } from '@allocab/allocab-passenger-shared-types';

import useFetchHelp from '../../hooks/useFetchHelp';
import { ToastManager } from '../../services/toast/utils';
import { t } from '../../services/translation/translation';
import { GradientButton } from '../button/GradientButton';

type Props = {
  trip: TripOutput;
  onClose: () => void;
};

export const HelpAuthenticatedButton = ({ trip, onClose }: Props) => {
  const { mutate: alertAllocab, isLoading: isLoadingAuthenticated } = useFetchHelp({
    onSuccess: () => {
      ToastManager.show({
        message: t('help-details-modal.alert-success'),
        severity: 'success',
      });
      onClose();
    },
  });

  return (
    <GradientButton
      className="w-full"
      onClick={() => alertAllocab({ key: trip.key })}
      isLoading={isLoadingAuthenticated}
    >
      {t('help-details-modal.alert-allocab')}
    </GradientButton>
  );
};
